import { render } from "./ClosureSummary.vue?vue&type=template&id=55e0cf07"
import script from "./ClosureSummary.vue?vue&type=script&lang=js"
export * from "./ClosureSummary.vue?vue&type=script&lang=js"

import "./ClosureSummary.vue?vue&type=style&index=0&id=55e0cf07&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__